import Vue from "vue";

import LabelCom from "./labelCom"

Vue.component(LabelCom.name, LabelCom);

import PickerCom from "./pickerCom"

Vue.component(PickerCom.name, PickerCom);

import InputCardBox from "./InputCardBox"

Vue.component(InputCardBox.name, InputCardBox);

import InputCard from "./InputCard"

Vue.component(InputCard.name, InputCard);



// WEBPACK FOOTER //
// ./src/components/index.js